// extracted by mini-css-extract-plugin
export default {"root":"Trust_root__UeXjN","inner":"Trust_inner__1bda3","title":"Trust_title__JTRln marketing_sectionTitle__njUls","stand":"Trust_stand__s3m6P","text":"Trust_text__573wq"};